import { f0FormField } from '@factorialco/f0-react'
import { z } from 'zod'

import i18n from 'modules/core/lib/i18n'
import ParticipantSelector from 'modules/planning/components/ManageCollaborators/ParticipantSelector'

export const createCollaboratorsStepSchema = () =>
  z.object({
    collaborators: f0FormField(
      z.array(
        z.object({
          employeeId: z.string(),
          role: z.union([z.literal('editor'), z.literal('viewer')]),
        })
      ),
      {
        fieldType: 'custom',
        label: i18n.t('planning.period_wizard.collaborators.step_title'),
        render: ({ value, onChange }) => (
          <ParticipantSelector selectedParticipants={value ?? []} onParticipantsChange={onChange} />
        ),
      }
    ),
  })
